module.exports = __webpack_public_path__ + "static/screenshot3-c3b974035167d7974cfe8ad471d75568.png";